import Client from '../client';
import { AxiosResponse } from 'axios';

export interface ParametroModel
{
    tipo: number,
    valor: number
}

const ConfiguracaoSistemaService = 
{
    obterParametro(tipo: number): Promise<void | AxiosResponse<ParametroModel>> 
    {
        return Client.get(`configuracao-sistema?tipo=${tipo}`);
    },
    enviarParametro(parametro: ParametroModel): Promise<void | AxiosResponse<any>> 
    {
        return Client.put('configuracao-sistema', parametro);
    }
}

export default ConfiguracaoSistemaService;